import { render, staticRenderFns } from "./ProuniPersonalDataForm.vue?vue&type=template&id=0a591991&scoped=true&"
import script from "./ProuniPersonalDataForm.vue?vue&type=script&lang=ts&"
export * from "./ProuniPersonalDataForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProuniPersonalDataForm.vue?vue&type=style&index=0&id=0a591991&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a591991",
  null
  
)

export default component.exports